/**
 * The game's full-screen height in CSS px. In the iOS Home Screen app `innerHeight` is a status bar short of the
 * screen the page draws on (base.css sizes #app to 100lvh there), so screen-space maths that spans
 * the whole screen (flying coins, camera bands, the hub frame) must use #app's height, not `innerHeight`.
 */
export function appHeight(): number {
  return document.getElementById("app")?.clientHeight || innerHeight;
}
